module.exports = __webpack_public_path__ + "img/PARQUE-SELE.19cc5803.jpg";